<div class="scroll-container" tabindex="0">
    <div class="row my-3">
        <div class="col px-4 py-2 card">
            <pace-header [notification]="notification">
                <div class="row my-1">
                    <a class="col-12 col-lg-auto btn btn-link text-start" (click)="openEquipmentHistory()">
                        <strong translate="NOTIFICATION_DETAILS_DETAIL_LINKS_EQUIPMENTS_TITLE"></strong> -
                        <strong translate="NOTIFICATION_DETAILS_DETAIL_LINKS_EQUIPMENT_HISTORY"></strong>
                    </a>
                    <a class="col-12 col-lg-auto btn btn-link text-start" (click)="openEquipmentConfig()">
                        <strong translate="NOTIFICATION_DETAILS_DETAIL_LINKS_EQUIPMENTS_TITLE"></strong> -
                        <strong translate="NOTIFICATION_DETAILS_DETAIL_LINKS_EQUIPMENT_SUB_EQUIPMENT"></strong>
                    </a>
                </div>
                <div class="row my-1">
                    <div class="col-4 d-none d-lg-block">
                        <fa-icon *ngIf="notification.userStatus" [icon]="faFlag" class="me-1"></fa-icon>
                        <span>{{ notification.userStatus }}</span>
                    </div>
                    <div class="col-4 d-none d-lg-block">
                        <pace-notification-status-badge
                            [notification]="notification"
                            [notificationStatus]="notification.updatedStatus"
                            [showUnreadIcon]="false"
                        ></pace-notification-status-badge>
                    </div>
                </div>
            </pace-header>
        </div>
    </div>
    <div class="row">
        <form class="col" [formGroup]="confirmationGroup">
            <pace-core-accordion
                *ngIf="model.equipment"
                [accordionOpened]="model.accordionOpenedStatus.equipment"
                (openChanged)="model.accordionOpenedStatus.equipment = true"
                [accordionInvalid]="equipmentChildren.invalid"
            >
                <div sectionHeader>
                    <span translate="CONFIRMATION_EQUIPMENT_LABEL"></span>
                </div>
                <div sectionBody>
                    <pace-confirmation-equipment
                        [model]="model.equipment"
                        [parentForm]="equipmentChildren"
                    ></pace-confirmation-equipment>
                </div>
                <div closeButton>
                    <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                </div>
            </pace-core-accordion>
            <pace-core-accordion
                *ngIf="model.complaints"
                [accordionOpened]="model.accordionOpenedStatus.complaints"
                (openChanged)="model.accordionOpenedStatus.complaints = true"
                [accordionInvalid]="complaintsChildren.invalid"
            >
                <div sectionHeader>
                    <span translate="CONFIRMATION_COMPLAINTS_LABEL"></span>
                </div>
                <div sectionBody>
                    <pace-confirmation-complaints-p58
                        [model]="model.complaints"
                        [parentForm]="complaintsChildren"
                    ></pace-confirmation-complaints-p58>
                </div>
                <div closeButton>
                    <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                </div>
            </pace-core-accordion>
            <pace-core-accordion
                *ngIf="model.materials"
                [accordionOpened]="model.accordionOpenedStatus.materials"
                (openChanged)="model.accordionOpenedStatus.materials = true"
                [accordionInvalid]="materialsChildren.invalid"
            >
                <div sectionHeader>
                    <span translate="CONFIRMATION_MATERIAL_LABEL"></span>
                </div>
                <div sectionBody>
                    <pace-confirmation-material-consume
                        [model]="model.materials"
                        [parentForm]="materialsChildren"
                    ></pace-confirmation-material-consume>
                </div>
                <div closeButton>
                    <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                </div>
            </pace-core-accordion>
            <pace-core-accordion
                *ngIf="model.measurementTool"
                [accordionOpened]="model.accordionOpenedStatus.measurementTool"
                (openChanged)="model.accordionOpenedStatus.measurementTool = true"
                [accordionInvalid]="measurementToolsChildren.invalid"
            >
                <div sectionHeader>
                    <span translate="CONFIRMATION_MEASUREMENT_TOOLS_LABEL"></span>
                </div>
                <div sectionBody>
                    <pace-confirmation-measurement-tools
                        [model]="model.measurementTool"
                        [parentForm]="measurementToolsChildren"
                    ></pace-confirmation-measurement-tools>
                </div>
                <div closeButton>
                    <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                </div>
            </pace-core-accordion>
            <pace-core-accordion
                *ngIf="model.measuringPoints"
                [accordionOpened]="model.accordionOpenedStatus.measuringPoints"
                (openChanged)="model.accordionOpenedStatus.measuringPoints = true"
                [accordionInvalid]="measuringPointsChildren.invalid"
            >
                <div sectionHeader>
                    <span translate="CONFIRMATION_MEASURING_POINTS_LABEL"></span>
                </div>
                <div sectionBody>
                    <pace-confirmation-measuring-points
                        [model]="model.measuringPoints"
                        [parentForm]="measuringPointsChildren"
                    ></pace-confirmation-measuring-points>
                </div>
                <div closeButton>
                    <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                </div>
            </pace-core-accordion>
            <pace-core-accordion
                *ngIf="model.serviceReport"
                [accordionOpened]="model.accordionOpenedStatus.serviceReport"
                (openChanged)="model.accordionOpenedStatus.serviceReport = true"
                [accordionInvalid]="serviceReportChildren.invalid"
            >
                <div sectionHeader>
                    <span translate="CONFIRMATION_SERVICE_REPORT_LABEL"></span>
                </div>
                <div sectionBody>
                    <pace-confirmation-service-report
                        [model]="model.serviceReport"
                        [parentForm]="serviceReportChildren"
                    ></pace-confirmation-service-report>
                </div>
                <div closeButton>
                    <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                </div>
            </pace-core-accordion>
            <pace-core-accordion
                *ngIf="model.timeRecording"
                [accordionOpened]="model.accordionOpenedStatus.timeRecording"
                (openChanged)="model.accordionOpenedStatus.timeRecording = true"
                [accordionInvalid]="timeRecordingChildren.invalid"
            >
                <div sectionHeader>
                    <span translate="CONFIRMATION_TIMERECORDING_LABEL"></span>
                </div>
                <div sectionBody>
                    <pace-confirmation-time-recording
                        [model]="model.timeRecording"
                        [parentForm]="timeRecordingChildren"
                    ></pace-confirmation-time-recording>
                </div>
                <div closeButton>
                    <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                </div>
            </pace-core-accordion>
            <pace-core-accordion
                *ngIf="model.expenses"
                [accordionOpened]="model.accordionOpenedStatus.expenses"
                (openChanged)="model.accordionOpenedStatus.expenses = true"
                [accordionInvalid]="expensesChildren.invalid"
            >
                <div sectionHeader>
                    <span translate="CONFIRMATION_EXPENSES_LABEL"></span>
                </div>
                <div sectionBody>
                    <pace-confirmation-expenses
                        [model]="model.expenses"
                        [parentForm]="expensesChildren"
                    ></pace-confirmation-expenses>
                </div>
                <div closeButton>
                    <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                </div>
            </pace-core-accordion>
            <pace-core-accordion
                *ngIf="model.uploadToDocBox"
                [accordionOpened]="model.accordionOpenedStatus.uploadToDocBox"
                (openChanged)="model.accordionOpenedStatus.uploadToDocBox = true"
                [accordionInvalid]="uploadToDocBoxChildren.invalid"
            >
                <div sectionHeader>
                    <span translate="CONFIRMATION_UPLOAD_TO_DOCBOX_LABEL"></span>
                </div>
                <div sectionBody>
                    <pace-confirmation-upload-to-docbox
                        [model]="model.uploadToDocBox"
                        [notification]="notification"
                        [parentForm]="uploadToDocBoxChildren"
                    ></pace-confirmation-upload-to-docbox>
                </div>
                <div closeButton>
                    <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                </div>
            </pace-core-accordion>
            <pace-core-accordion
                *ngIf="model.participants"
                [accordionOpened]="model.accordionOpenedStatus.participants"
                (openChanged)="model.accordionOpenedStatus.participants = true"
                [accordionInvalid]="participantsChildren.invalid"
            >
                <div sectionHeader>
                    <span translate="CONFIRMATION_PARTICIPANTLIST_LABEL"></span>
                </div>
                <div sectionBody>
                    <pace-confirmation-participants
                        [model]="model.participants"
                        [parentForm]="participantsChildren"
                    ></pace-confirmation-participants>
                </div>
                <div closeButton>
                    <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                </div>
            </pace-core-accordion>
            <pace-core-accordion
                *ngIf="model.sourceReplacements"
                [accordionOpened]="model.accordionOpenedStatus.sourceReplacements"
                (openChanged)="model.accordionOpenedStatus.sourceReplacements = true"
                [accordionInvalid]="sourceReplacementsChildren.invalid"
            >
                <div sectionHeader>
                    <span translate="CONFIRMATION_SOURCE_REPLACEMENTS_LABEL"></span>
                </div>
                <div sectionBody>
                    <pace-confirmation-source-replacements
                        [model]="model.sourceReplacements"
                        [parentForm]="sourceReplacementsChildren"
                    ></pace-confirmation-source-replacements>
                </div>
                <div closeButton>
                    <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                </div>
            </pace-core-accordion>
            <pace-core-accordion
                *ngIf="model.followup && showFollowup"
                [accordionOpened]="model.accordionOpenedStatus.followup"
                (openChanged)="model.accordionOpenedStatus.followup = true"
                [accordionInvalid]="followupChildren.invalid"
            >
                <div sectionHeader>
                    <span translate="CONFIRMATION_FOLLOWUP_LABEL"></span>
                </div>
                <div sectionBody>
                    <pace-confirmation-followup
                        [model]="model.followup"
                        [parentForm]="followupChildren"
                    ></pace-confirmation-followup>
                </div>
                <div closeButton>
                    <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                </div>
            </pace-core-accordion>

            <pace-core-accordion
                *ngIf="model.timeRecordingP40"
                [accordionOpened]="model.accordionOpenedStatus.timeRecordingP40"
                (openChanged)="model.accordionOpenedStatus.timeRecordingP40 = true"
                [accordionInvalid]="timeRecordingP40Children.invalid"
                [displayStatusIcon]="displayStatusIcons"
            >
                <div sectionHeader>
                    <span translate="CONFIRMATION_TIME_RECORDING_P40_LABEL"></span>
                </div>
                <div sectionBody>
                    <pace-confirmation-time-recording-p40
                        [model]="model.timeRecordingP40"
                        [parentForm]="timeRecordingP40Children"
                        (savedTimeRecording)="save()"
                    ></pace-confirmation-time-recording-p40>
                </div>
                <div closeButton>
                    <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                </div>
            </pace-core-accordion>

            <pace-core-accordion
                *ngIf="model.attendees"
                [accordionOpened]="model.accordionOpenedStatus.attendees"
                (openChanged)="model.accordionOpenedStatus.attendees = true"
                [accordionInvalid]="attendeesChildren.invalid"
                [displayStatusIcon]="displayStatusIcons"
            >
                <div sectionHeader>
                    <span translate="CONFIRMATION_ATTENDEELIST_LABEL"></span>
                </div>
                <div sectionBody>
                    <pace-confirmation-attendees
                        [model]="model.attendees"
                        [notificationId]="notification.identifier"
                        [parentForm]="attendeesChildren"
                        (savedAttendee)="save()"
                    ></pace-confirmation-attendees>
                </div>
                <div closeButton>
                    <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                </div>
            </pace-core-accordion>

            <pace-core-accordion
                *ngIf="model.interruptions"
                [accordionOpened]="model.accordionOpenedStatus.interruptions"
                (openChanged)="model.accordionOpenedStatus.interruptions = true"
                [accordionInvalid]="interruptionsChildren.invalid"
                [displayStatusIcon]="displayStatusIcons"
            >
                <div sectionHeader>
                    <span translate="CONFIRMATION_INTERRUPTIONS_LABEL"></span>
                </div>
                <div sectionBody>
                    <pace-confirmation-interruptions
                        [model]="model.interruptions"
                        [parentForm]="interruptionsChildren"
                    ></pace-confirmation-interruptions>
                </div>
                <div closeButton>
                    <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                </div>
            </pace-core-accordion>
            <pace-core-accordion
                *ngIf="model.additionalEmails"
                [accordionOpened]="model.accordionOpenedStatus.additionalEmails"
                (openChanged)="model.accordionOpenedStatus.additionalEmails = true"
                [accordionInvalid]="additionalEmailsChildren.invalid"
                [displayStatusIcon]="displayStatusIcons"
            >
                <div sectionHeader>
                    <span translate="CONFIRMATION_ADDITIONAL_EMAILS_LABEL"></span>
                </div>
                <div sectionBody>
                    <pace-confirmation-additional-emails
                        [model]="model.additionalEmails"
                        [parentForm]="additionalEmailsChildren"
                    ></pace-confirmation-additional-emails>
                </div>
                <div closeButton>
                    <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                </div>
            </pace-core-accordion>
            <pace-core-accordion
                *ngIf="model.eventSummary"
                [accordionOpened]="model.accordionOpenedStatus.eventSummary"
                (openChanged)="model.accordionOpenedStatus.eventSummary = true"
                [accordionInvalid]="eventSummaryChildren.invalid"
                [displayStatusIcon]="displayStatusIcons"
            >
                <div sectionHeader>
                    <span translate="CONFIRMATION_EVENT_SUMMARY_LABEL"></span>
                </div>
                <div sectionBody>
                    <pace-confirmation-event-summary
                        [model]="model.eventSummary"
                        [parentForm]="eventSummaryChildren"
                    ></pace-confirmation-event-summary>
                </div>
                <div closeButton>
                    <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                </div>
            </pace-core-accordion>
            <pace-core-accordion
                *ngIf="model.reportText"
                [accordionOpened]="model.accordionOpenedStatus.reportText"
                (openChanged)="model.accordionOpenedStatus.reportText = true"
                [accordionInvalid]="reportTextChildren.invalid"
                [displayStatusIcon]="displayStatusIcons"
            >
                <div sectionHeader>
                    <span translate="CONFIRMATION_REPORT_TEXT_LABEL"></span>
                </div>
                <div sectionBody>
                    <pace-confirmation-report-text
                        [model]="model.reportText"
                        [parentForm]="reportTextChildren"
                    ></pace-confirmation-report-text>
                </div>
                <div closeButton>
                    <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                </div>
            </pace-core-accordion>
            <pace-core-accordion
                *ngIf="model.commentsForCustomer"
                [accordionOpened]="model.accordionOpenedStatus.commentsForCustomer"
                (openChanged)="model.accordionOpenedStatus.commentsForCustomer = true"
                [accordionInvalid]="commentsForCustomerChildren.invalid"
                [displayStatusIcon]="displayStatusIcons"
            >
                <div sectionHeader>
                    <span translate="CONFIRMATION_COMMENTS_FOR_CUSTOMER_LABEL"></span>
                </div>
                <div sectionBody>
                    <pace-confirmation-comments-for-customer
                        [model]="model.commentsForCustomer"
                        [parentForm]="commentsForCustomerChildren"
                    ></pace-confirmation-comments-for-customer>
                </div>
                <div closeButton>
                    <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                </div>
            </pace-core-accordion>
            <pace-core-accordion
                *ngIf="model.trainingEventCompleted"
                [accordionOpened]="model.accordionOpenedStatus.trainingEventCompleted"
                (openChanged)="model.accordionOpenedStatus.trainingEventCompleted = true"
                [accordionInvalid]="trainingEventCompletedChildren.invalid"
                [displayStatusIcon]="displayStatusIcons"
            >
                <div sectionHeader>
                    <span translate="CONFIRMATION_TRAINING_EVENT_LABEL"></span>
                </div>
                <div sectionBody>
                    <pace-confirmation-training-event
                        [model]="model.trainingEventCompleted"
                        [parentForm]="trainingEventCompletedChildren"
                    ></pace-confirmation-training-event>
                </div>
                <div closeButton>
                    <span translate="CONFIRMATION_CLOSE_SECTION_LABEL"></span>
                </div>
            </pace-core-accordion>
        </form>
    </div>
</div>

<nav class="navbar bg-light fixed-bottom safe-area-navbar-bottom" *ngrxLet="isOnline$; let isOnline">
    <ul class="navbar-nav">
        <li *ngIf="showPaceFormsQuickAccess" class="nav-item ps-2">
            <button class="btn btn-lg btn-success" type="button" (click)="navigateToPaceForms()">
                {{ strings.paceFormsQuickAccessLabel }}
            </button>
        </li>
    </ul>
    <ul class="navbar-nav flex-row flex-grow-1 justify-content-end px-2">
        <ng-container *ngIf="isPaceUSClient; else nonPaceUSClient">
            <li class="nav-item me-2 d-none d-md-block">
                <button class="btn btn-lg btn-secondary nav-item" type="button" (click)="save()">
                    <span>{{ strings.saveButtonLabel }}</span>
                </button>
            </li>
            <li class="nav-item me-2">
                <button
                    class="btn btn-lg btn-primary nav-item"
                    type="button"
                    (click)="submitForUS()"
                    [disabled]="confirmationGroup.invalid || notAllSectionsOpened()"
                >
                    {{ strings.submitButtonLabel }}
                </button>
            </li>
        </ng-container>
        <ng-template #nonPaceUSClient>
            <li class="nav-item me-2 d-none d-md-block">
                <button
                    class="btn btn-lg btn-secondary nav-item button-width"
                    type="button"
                    (click)="refreshConfirmation()"
                    [disabled]="
                        !isOnline ||
                        downloadStatus() === confirmationStatus.LOADING ||
                        uploadStatus() === confirmationStatus.LOADING
                    "
                >
                    <ng-container
                        *ngTemplateOutlet="
                            statusButtonContent;
                            context: {
                                status: isOnline ? downloadStatus() : false,
                                label: strings.downloadButtonLabel,
                            }
                        "
                    >
                    </ng-container>
                </button>
            </li>
            @if (isOnline) {
                <li class="nav-item me-2 d-none d-md-block">
                    <button
                        id="confirmationSummaryUploadButton"
                        class="btn btn-lg btn-secondary nav-item button-width"
                        type="button"
                        (click)="saveAndBackup()"
                        [disabled]="
                            downloadStatus() === confirmationStatus.LOADING ||
                            uploadStatus() === confirmationStatus.LOADING
                        "
                    >
                        <ng-container
                            *ngTemplateOutlet="
                                statusButtonContent;
                                context: {
                                    status: uploadStatus(),
                                    label: strings.uploadButtonLabel,
                                }
                            "
                        >
                        </ng-container>
                    </button>
                </li>
            } @else {
                <ng-container
                    *ngTemplateOutlet="saveButton; context: { extraListClass: 'me-2 d-none d-md-block' }"
                ></ng-container>
            }
            <li class="nav-item me-2 d-none d-md-block">
                <button
                    class="btn btn-lg btn-secondary nav-item"
                    type="button"
                    (click)="signLater()"
                    [disabled]="confirmationGroup.invalid || notAllSectionsOpened()"
                >
                    {{ strings.signLaterButtonLabel }}
                </button>
            </li>
            <li class="nav-item">
                <button
                    class="btn btn-lg btn-primary nav-item"
                    type="button"
                    (click)="sign()"
                    [disabled]="confirmationGroup.invalid || notAllSectionsOpened()"
                >
                    {{ strings.signButtonLabel }}
                </button>
            </li>
        </ng-template>
        <ng-template #statusButtonContent let-status="status" let-label="label">
            <ng-container [ngSwitch]="status">
                <ng-container *ngSwitchCase="confirmationStatus.LOADING">
                    <fa-icon [icon]="faLoading" [spin]="true"></fa-icon>
                </ng-container>

                <ng-container *ngSwitchCase="confirmationStatus.SUCCESS">
                    {{ label }}
                    <fa-icon [icon]="faCheckCircle" class="text-success"></fa-icon>
                </ng-container>

                <ng-container *ngSwitchCase="confirmationStatus.ERROR">
                    {{ label }}
                    <fa-icon [icon]="faExclamationTriangle" class="text-danger"></fa-icon>
                </ng-container>

                <ng-container *ngSwitchCase="false">
                    {{ label }}
                    <fa-icon [icon]="faBan"></fa-icon>
                </ng-container>

                <ng-container *ngSwitchDefault>
                    {{ label }}
                </ng-container>
            </ng-container>
        </ng-template>
    </ul>
    <div class="btn-group d-md-none pe-2" dropdown [dropup]="true">
        <button
            id="button-toggler"
            dropdownToggle
            type="button"
            class="btn btn-lg btn-secondary"
            aria-controls="dropdown-toggler"
            [attr.aria-label]="'CONFIRMATION_ACTIONS_MENU' | translate"
        >
            <fa-icon [icon]="faEllipsisV"></fa-icon>
        </button>
        <ul
            id="dropdown-toggler"
            *dropdownMenu
            class="dropdown-menu dropdown-menu-right vw-100"
            role="menu"
            aria-labelledby="button-toggler"
        >
            <ng-container *ngIf="isPaceUSClient; else nonPaceUSClient">
                <li class="nav-item" role="menuitem">
                    <button class="btn btn-lg btn-secondary nav-item w-100" type="button" (click)="save()">
                        <span>{{ strings.saveButtonLabel }}</span>
                    </button>
                </li>
            </ng-container>
            <ng-template #nonPaceUSClient>
                <li class="nav-item" role="menuitem">
                    <button
                        class="btn btn-lg btn-secondary nav-item w-100"
                        type="button"
                        (click)="refreshConfirmation()"
                        [disabled]="!isOnline"
                    >
                        {{ strings.downloadButtonLabel }}
                        <fa-icon *ngIf="!isOnline" [icon]="faBan"></fa-icon>
                    </button>
                </li>
                @if (isOnline) {
                    <li class="nav-item" role="menuitem">
                        <button class="btn btn-lg btn-secondary nav-item w-100" type="button" (click)="saveAndBackup()">
                            <span>{{ strings.uploadButtonLabel }}</span>
                        </button>
                    </li>
                } @else {
                    <ng-container *ngTemplateOutlet="saveButton; context: { extraButtonClass: 'w-100' }"></ng-container>
                }
                <li class="nav-item" role="menuitem">
                    <button
                        class="btn btn-lg btn-secondary nav-item w-100"
                        type="button"
                        (click)="signLater()"
                        [disabled]="confirmationGroup.invalid || notAllSectionsOpened()"
                    >
                        {{ strings.signLaterButtonLabel }}
                    </button>
                </li>
            </ng-template>
        </ul>
    </div>
    <ng-template #saveButton let-extraListClass="extraListClass" let-extraButtonClass="extraButtonClass">
        <li class="nav-item" [ngClass]="extraListClass || null">
            <button
                class="btn btn-lg btn-secondary nav-item"
                [ngClass]="extraButtonClass || null"
                type="button"
                (click)="save()"
                id="confirmationSummarySaveButton"
            >
                <span>{{ strings.saveButtonLabel }}</span>
            </button>
        </li>
    </ng-template>
</nav>
